import React, { useEffect, useState, useContext } from "react";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { timesheetreportService } from "../../services/timesheetreportsService";
import { timesheetService } from "../../services/timesheetService";
import { formatterhelper } from "../../helpers/dateformatter";
import { Paginator } from "primereact/paginator";
import { loader } from "../../compnents/loadermd";
import { dataExporthelper } from "../../helpers/exporthelper";
import { BsGraphDownArrow } from "react-icons/bs";
import { BsGraphUpArrow } from "react-icons/bs";


import { TabView, TabPanel } from 'primereact/tabview';
import { roletype } from "../../global";
import {adminService} from '../../services/adminService';

var XLSX = require("xlsx");
const AnalysisReports = ({ tabname }) => {
  const [formData, setFormData] = useState({
    fromdate: "",
    todate: "",
    employee: "Select Employee",
    client: "ALL",
    subclient: "ALL",
  });
  const [datacomp, setDatacomp] = useState({ client: [], subclient: [] });
  const [datacomp2, setDatacomp2] = useState({ client: [], subclient: [],total_actual:'' });
  const [dataavail, setDatastate] = useState(false);
  const [cleintscomp, setClientscomp] = useState([]);
  const [subclientscomp, setsubClientscomp] = useState([]);
  const [empcomp, setempcomp] = useState([]);
  const [totalpages, setPages] = useState(0);
  const [filterobj, setfilterobj] = useState({});
  const userdata =
    localStorage.getItem("user") != ""
      ? JSON.parse(localStorage.getItem("user"))
      : {};
  const [isloaded, setloading] = useState(true);
  const [isdataexported, setDataexport] = useState(true);

  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(15);
  const [errors, setErrors] = useState({});
  const [format, setformat] = useState("client_wise");
  const [rolesdata, setRoles] = useState([]);

  useEffect(() => {
    getemplist();
    _getclientslist();
    _getrole();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    if (name == "client") {
      _getsubclient({ clientid: value });
    }
  };

  const validateForm = () => {
    let valid = true;
    const newErrors = {};

    if (formData.fromdate == "") {
      newErrors.fromdate = "Field is required";
      valid = false;
    }

    if (formData.todate == "") {
      newErrors.todate = "Field is required";
      valid = false;
    }

    if (formData.employee == "") {
      newErrors.employee = "Field is required";
      valid = false;
    }

    if (formData.client == "") {
      newErrors.client = "Field is required";
      valid = false;
    }

    if (formData.subclient == "") {
      newErrors.subclient = "Field is required";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // if(!validateForm()){
    //      return;
    // }
    let reportobj = {
      clientid: formData.client,
      subclientid: formData.subclient,
      frmdt: formatterhelper.dateformatter({ date: formData.fromdate }),
      format: format,
      roletype: formData.roletype,
      dept: formData.dept,
    };
    //console.log(reportobj);
    setfilterobj(reportobj);
    getreports({ reportobj: reportobj });
    // Now you can perform any further actions with the form data
  };

  function Graphdata({ value }) {
    try{
      if (value > "0") {
        return <BsGraphUpArrow style={{ color: "green" }} />;
      } else {
        return <BsGraphDownArrow style={{ color: "red" }} />;
      }
    }catch(e){
      return  <></>;
    }
    // console.log(typeof value, "value check");
    
  }

  function getreports({ reportobj, pageno }) {
    let emparr = [];
    let subclientarr = [];
    setloading(false);
    timesheetreportService
      .showreportanalysis({ formdataobj: reportobj, pageno: pageno })
      .then((response) => {
        console.log(response.data.data, "response data show report analysis");
        if (response.status == 200) {
          response.data.data.forEach((value, index) => {
            let role =
              value.user_role == null ? value.user_roletype : value.user_role;
            emparr.push(
              <tr>
                <td>{index + 1}</td>
                <td style={{ textAlign: "left" }}>{value.client}</td>
                {format === "subclient_wise" && (
                  <td style={{ textAlign: "left" }}>{value.subclient}</td>
                )}
                {/* <td>{value.user_roletype}</td> */}
                <td>{value.dept}</td>
                <td>{value.month}</td>
                <td>{value.year}</td>
                <td>{value.total_worked_hrs1}</td>
                <td>{value.total_billing_hrs1}</td>
                <td>{value.totalclient_bill_hrs}</td>
                <td>
                  {value.total_diff_hrs1} &nbsp;&nbsp;{" "}
                  <Graphdata value={value.total_diff_hrs1} />
                </td>
              </tr>
            );
          });


          response.data?.subclient?.forEach((value, index) => {
            let role =
              value.user_role == null ? value.user_roletype : value.user_role;
            subclientarr.push(
              <tr>
                <td>{index + 1}</td>
                <td style={{ textAlign: "left" }}>{value.client}</td>
                {format === "subclient_wise" && (
                  <td style={{ textAlign: "left" }}>{value.subclient}</td>
                )}
                {format === "subclient_wise" && (<>
                <td>{value.roletype}</td>
                <td>{value.dept}</td> </>)}
                <td>{value.month}</td>
                <td>{value.year}</td>
                <td>{value.total_worked_hrs1}</td>
                <td>{value.total_billing_hrs1}</td>
                {/* <td>{value.totalclient_bill_hrs}</td> */}
                <td>
                  {value.total_diff_hrs1} &nbsp;&nbsp;{" "}
                  <Graphdata value={value.total_diff_hrs1} />
                </td>
              </tr>
            );
          });

          let totalpage = response.data.data.total;
          setPages(totalpage);
          setDatacomp({ client: emparr, subclient: subclientarr,total_actual:response.data.total_actual,total_bill:response.data.total_bill });

          setDatastate(true);
          setloading(true);
        } else {
          setDatacomp({ client: [], subclient: [] });

          setDatastate(false);
          setloading(true);
          setPages(0);
        }
      })
      .catch((error) => {
        console.log(error);
        setDatacomp({ client: [], subclient: [] });
        setDatacomp2({ client: [], subclient: [] });
        setDatastate(false);
        setloading(true);
        setPages(0);
      });
  }

  function _getrole(){
          let emparr = [];
          // setloading(false);
  
          adminService.getrole().then((response)=>{
            //  console.log('response'); 
          //    console.log(response.data.data); 
             response.data.data.forEach((value,index)=>{
              //  console.log(value.name);
               emparr.push(<option value={value.rolename}>{value.rolename}</option>);
             });

             let objarr = [
              <option value='Senior Analyst'>Senior Analyst</option>,
              <option value='Direct FTE'>Direct FTE</option>,
              <option value='Manager'>Manager</option>,
              <option value='Reviewer'>Reviewer</option>,
             ];
             
            setRoles(objarr);
          //    const [datacomp,setDatacomp] = useState([]); 
          }).catch((error)=>{
            setRoles([]);
              // setloading(true);
              // setDatastate(true);
          });
      } 

  function getemplist() {
    let member = userdata.id;
    let managerid = member;
    let emparr = [];
    timesheetreportService
      .getemployeelist({ managerid: managerid })
      .then((response) => {
        console.log(response);
        response.data.data.forEach((value, index) => {
          emparr.push(<option value={value.id}>{value.name}</option>);
        });
        setempcomp(emparr);
      })
      .catch((error) => {});
  }

  function _getclientslist() {
    let managerid = 1;
    let emparr = [];
    timesheetreportService
      .getclientslist({ managerid: managerid })
      .then((response) => {
        // console.log(response);
        response.data.data.forEach((value, index) => {
          if (value.client != "") {
            emparr.push(<option value={value.client}>{value.client}</option>);
          }
        });
        setClientscomp(emparr);
      })
      .catch((error) => {});
  }

  function _getsubclient({ clientid }) {
    try {
      let _clientid = clientid;
      let emparr = [];
      timesheetService
        .getallsubclient({ client: _clientid })
        .then((response) => {
          // console.log(response);
          if (response != undefined) {
            response.data.data.forEach((value, index) => {
              if (value.subclient != "") {
                emparr.push(
                  <option value={value.subclient}>{value.subclient}</option>
                );
              }
            });
            setsubClientscomp(emparr);
          }
        })
        .catch((error) => {});
    } catch (e) {
      console.log(e);
    }
  }

  const onPageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
    let pageno = 1;
    if (event.first == 0) {
      pageno = 1;
    } else {
      pageno = event.first / rows + 1;
    }
    // getUsers(pageno);
    getreports({ reportobj: filterobj, pageno: pageno });
    // console.log(pageno);
  };

  const exportexcel = ({ id }) => {
    // getreports({reportobj:filterobj,pageno:pageno});
    // console.log("filter object");
    // console.log(filterobj);
    //     if(!validateForm()){
    //         return;
    //    }
    let filterobj = {
      clientid: formData.client,
      employeeid: formData.employee,
      frmdt: formatterhelper.dateformatter({ date: formData.fromdate }),
      todt: formatterhelper.dateformatter({ date: formData.todate }),
      subclientid: formData.subclient,
    };

    //   setDataexport(false);
    exportToExcel();
    //    timesheetreportService.showrptexporttoexcel({formdataobj:filterobj}).then((response)=>{
    //     console.log("response");
    //     console.log(response.data.data);
    //     exportToExcel(response.data.data);
    //     setDataexport(true);
    //    });
  };

  function exportToExcel({ id }) {
    dataExporthelper.exportFromhtml({
      id: `${id}`,
      reportname: "Report and analysis",
    });
    // const ws = XLSX.utils.json_to_sheet(data);
    // const wb = XLSX.utils.book_new();
    // XLSX.utils.book_append_sheet(wb, ws, 'Sheet 1');
    // XLSX.writeFile(wb, 'exported_data.xlsx');
  }


  useEffect(() => {
    console.log("format changed");
     setDatacomp({ client: [], subclient: [],total_actual:0,total_bill:0});
  }, [format]);

  return (
    <>
      <div className="invisible-divider-sm"></div>
      <h6 className="ps-3">{tabname}</h6>
      <div className="card card-custom-style card-style-padding">
        
         <TabView activeIndex={format === "client_wise" ? 0 : 1} onTabChange={(e) => setformat(e.index === 0 ? "client_wise" : "subclient_wise")}>
            <TabPanel header="Client Wise Reports">
                   <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-2">
                  <label className="pull-left">Select Month</label>
                  <Calendar
                    value={formData.fromdate}
                    name="fromdate"
                    onChange={handleChange}
                    className="calender-custom-style"
                    required
                    view="month"
                    dateFormat="mm/yy"
                  />
                  {errors.fromdate && (
                    <span className="error">{errors.fromdate}</span>
                  )}
                </div>

                {/* <div className="col-md-2">
                        <label className='pull-left'>Employee</label>
                        <select className='form-control' required name="employee" value={formData.employee} onChange={handleChange}>
                            <option value=''>Select Employee</option>
                            {empcomp}
                        </select>
                        {errors.employee && <span className='error'>{errors.employee}</span>}
                    </div> */}
                <div className="col-md-2">
                  <label className="pull-left">Client</label>
                  <select
                    className="form-control"
                    name="client"
                    value={formData.client}
                    onChange={handleChange}
                  >
                    <option value="ALL">ALL</option>
                    {cleintscomp}
                  </select>
                  {errors.client && (
                    <span className="error">{errors.client}</span>
                  )}
                </div>

                <div className="col-md-2">
                        <label className='pull-left'>Select Dept</label>
                        <select className='form-control' required name="dept" value={formData.dept} onChange={handleChange}>
                            <option value=''>Select Department</option>
                            <option value='ALL'>All</option>
                             <option value='Audit Team'>Audit</option>
                              <option value='Support Team'>Support</option>
                               <option value='Year end'>Year end</option>
                               <option value='Ops- Offshore Accountants (2003)'>Ops- Offshore Accountants (2003)</option>

                        </select>
                        {/* {errors.employee && <span className='error'>{errors.employee}</span>} */}
                    </div>   
                {/* <div className="col-md-2">
                        <label className='pull-left'>Subclient</label>
                        <select className='form-control' name='subclient' value={formData.subclient} onChange={handleChange}>
                            <option value='ALL'>ALL</option>
                            {subclientscomp}
                        </select>
                        {errors.subclient && <span className='error'>{errors.subclient}</span>}
                    </div> */}
                <div className="col-md-4">
                  <div className="button-wrapper-style">
                    <Button
                      type="submit"
                      stype="button"
                      label="Show"
                      severity="success"
                      rounded
                      className="custom-btn-style"
                    />
                    &nbsp;&nbsp;&nbsp;
                    <Button
                      type="button"
                      stype="button"
                      label="Export"
                      severity="info"
                      rounded
                      className="custom-btn-style"
                      onClick={() =>
                        exportToExcel({ id: "analysis-report-table" })
                      }
                    >
                      {" "}
                      {!isdataexported ? loader.Loadermd() : <></>}
                    </Button>
                  </div>
                </div>
              </div>
            </form>
            <div className="invisible-divider-sm"></div>
            <div className="card card-custom-style card-style-padding">
              <div className="row">
                <div className="col-md-6"></div>
                <div className="pagination col-md-6">
                  <span>Actual Hours : {datacomp?.total_actual}</span>
                  &nbsp;&nbsp;&nbsp;
                  <span>Total Bill : {datacomp?.total_bill}</span>
                  {/* <PaginationExample items={totalpages} currentPaged={currentPage} lastpage={last_page} perpage={per_page} getuserfun={getUsers}/> */}
                  {/* {isloaded && dataavail ? (
                    <Paginator
                      first={first}
                      rows={rows}
                      totalRecords={totalpages}
                      rowsPerPageOptions={[15]}
                      onPageChange={onPageChange}
                    />
                  ) : (
                    <></>
                  )} */}
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  {!isloaded ? (
                    loader.Loadermd()
                  ) : dataavail ? (
                    <table
                      class="table table-bordered"
                      id="analysis-report-table"
                    >
                      <thead>
                        <tr>
                          <th scope="col">Id</th>
                          <th scope="col" style={{ textAlign: "left" }}>
                            Client
                          </th>
                          {/* <th scope="col">Sub Client</th> */}
                          {/* <th scope="col">Role type</th> */}
                          <th scope="col">Dept</th>
                          <th scope="col">Month</th>
                          <th scope="col">Year</th>
                          <th scope="col">Actual (Hrs)</th>
                          <th scope="col">Billed (Hrs)</th>
                          <th scope="col">Client Bill (Hrs)</th>
                          <th scope="col">
                            Total Spent Diff (Hrs) <br /> (Actual - Bill)
                          </th>
                         
                        </tr>
                      </thead>
                      <tbody>{datacomp?.client}</tbody>
                    </table>
                  ) : (
                    <p>No data Found</p>
                  )}
                </div>
              </div>
            </div>
            </TabPanel>

            <TabPanel header="Subclient Wise Reports">
                  <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-2">
                  <label className="pull-left">Select Month</label>
                  <Calendar
                    value={formData.fromdate}
                    name="fromdate"
                    onChange={handleChange}
                    className="calender-custom-style"
                    required
                    view="month"
                    dateFormat="mm/yy"
                  />
                  {errors.fromdate && (
                    <span className="error">{errors.fromdate}</span>
                  )}
                </div>

                <div className="col-md-2">
                        <label className='pull-left'>Select Role Type</label>
                        <select className='form-control' required name="roletype" value={formData.roletype} onChange={handleChange}>
                            <option value=''>Select Role Type</option>
                            <option value='ALL'>All</option>
                            {rolesdata}
                        </select>
                        {/* {errors.employee && <span className='error'>{errors.employee}</span>} */}
                    </div>

                <div className="col-md-2">
                        <label className='pull-left'>Select Dept</label>
                        <select className='form-control' required name="dept" value={formData.dept} onChange={handleChange}>
                            <option value=''>Select Department</option>
                            <option value='ALL'>All</option>
                             <option value='Audit Team'>Audit</option>
                              <option value='Support Team'>Support</option>
                               <option value='Year end'>Year end</option>
                               <option value='Ops- Offshore Accountants (2003)'>Ops- Offshore Accountants (2003)</option>

                        </select>
                        {/* {errors.employee && <span className='error'>{errors.employee}</span>} */}
                    </div>    

                 
                <div className="col-md-2">
                  <label className="pull-left">Client</label>
                  <select
                    className="form-control"
                    name="client"
                    value={formData.client}
                    onChange={handleChange}
                  >
                    <option value="ALL">ALL</option>
                    {cleintscomp}
                  </select>
                  {errors.client && (
                    <span className="error">{errors.client}</span>
                  )}
                </div>
                <div className="col-md-2">
                  <label className="pull-left">Subclient</label>
                  <select
                    className="form-control"
                    name="subclient"
                    value={formData.subclient}
                    onChange={handleChange}
                  >
                    <option value="ALL">ALL</option>
                    {subclientscomp}
                  </select>
                  {errors.subclient && (
                    <span className="error">{errors.subclient}</span>
                  )}
                </div>
                <div className="col-md-4">
                
                  <div className="button-wrapper-style">
                    <Button
                      type="submit"
                      stype="button"
                      label="Show"
                      severity="success"
                      rounded
                      className="custom-btn-style"
                    />
                    &nbsp;&nbsp;&nbsp;
                    <Button
                      type="button"
                      stype="button"
                      label="Export"
                      severity="info"
                      rounded
                      className="custom-btn-style"
                      onClick={() =>
                        exportToExcel({ id: "analysisreporttable2" })
                      }
                    >
                      {" "}
                      {!isdataexported ? loader.Loadermd() : <></>}
                    </Button>
                  </div>
                </div>
              </div>
            </form>
            <div className="invisible-divider-sm"></div>
            <div className="card card-custom-style">
              <div className="row">
                <div className="col-md-6"></div>
                <div className="pagination col-md-6">
                  <span>Actual Hours : {datacomp?.total_actual}</span>
                  &nbsp;&nbsp;&nbsp;
                  <span>Total Bill : {datacomp?.total_bill}</span>
                  {/* {isloaded && dataavail ? (
                    <Paginator
                      first={first}
                      rows={rows}
                      totalRecords={totalpages}
                      rowsPerPageOptions={[15]}
                      onPageChange={onPageChange}
                    />
                  ) : (
                    <></>
                  )} */}
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  {!isloaded ? (
                    loader.Loadermd()
                  ) : dataavail ? (
                    <table
                      class="table table-bordered"
                      id="analysisreporttable2"
                    >
                      <thead>
                        <tr>
                          <th scope="col">Id</th>
                          <th scope="col" style={{ textAlign: "left" }}>
                            Client
                          </th>
                          {format === "subclient_wise" && (
                            <th scope="col" style={{ textAlign: "left" }}>
                              Sub Client
                            </th>
                          )}
                          <th scope="col">Role type</th>
                          <th scope="col">Dept</th>
                          <th scope="col">Month</th>
                          <th scope="col">Year</th>
                          <th scope="col">Actual (Hrs)</th>
                          <th scope="col">Billed (Hrs)</th>
                          {/* <th scope="col">Client Bill (Hrs)</th> */}
                          <th scope="col">
                            Total Spent Diff (Hrs) <br /> (Actual - Bill)
                          </th>
                        </tr>
                      </thead>
                      <tbody>{datacomp?.subclient}</tbody>
                    </table>
                  ) : (
                    <p>No data Found</p>
                  )}
                </div>
              </div>
            </div>
            </TabPanel>

         </TabView>
      </div>

      <div className="invisible-divider-sm"></div>
      {/* <div className="row">
                <h1>table</h1>
            </div> */}
    </>
  );
};

export default AnalysisReports;
